import React, {Component} from 'react';
import StaticFunctions from "../StaticFunctions";

/**
 *  type: PropTypes.string,
 *  payload: PropTypes.array,
 *  label: PropTypes.string,
 */
class ToolTipPieChart extends Component {

    constructor(props) {

        super(props);

    }

    getName() {

        const {payload} = this.props;

        if (payload[0]) return payload[0].name;

        return null;

    }

    getPayLoad() {

        const {payload} = this.props;

        if (payload[0]) return payload[0];

        return null;

    }

    renderTableRows() {

        const {translate, payload} = this.props;

        if (!payload) return null;

        return payload.map(
            (data, index) => {
                return (
                    <tr key={'payload-' + index} style={{color: data.payload.fill}}>
                        <td className="text-left" style={{paddingRight: 5}}>{translate('time')}:</td>
                        <td className="text-right">{StaticFunctions.convertSecondsToFormatedString(data.value)}</td>
                    </tr>
                );
            }
        );

    }

    render() {

        const {active} = this.props;
        const payload = this.getPayLoad();

        if (!active || !payload) return null;

        const name = payload.name;
        const tableRows = this.renderTableRows();

        return (
            <div className="custom-tooltip" style={{backgroundColor: "white", padding: 5}}>
                <p>{name}</p>

                <table>
                    <tbody>
                        {tableRows}
                    </tbody>
                </table>
            </div>
        );

    }

}

export default ToolTipPieChart;